import React from 'react';
import _get from 'lodash.get';
import { isApp } from 'utils/getParams';
import { commonHeadScripts } from 'helpers/scripts/headScripts';
import {
  loadLayoutDataTopic,
  loadLayoutDataList,
} from 'reduxUtils/modules_v2/layout';
import {
  getSiteConfig,
  updateCaimpaignAdsConfig,
} from 'reduxUtils/modules/common';
import {
  setSubSecNavFrmUrl,
  checkJarvisAdsConfigForSS,
} from 'helpers/ads/utils';
import {
  loadTopicData,
  // loadTopicTabData,
  // loadPubOrderList,
  loadTopicFilterData,
  // loadKeywordsFacetData,
  loadTopStoriesData,
  loadSearchRedirectionData,
} from 'routes/topic/redux';
// import DEFAULT_TOPIC_DATA_WEB from 'routes/topic/defaultTopicData';
import { isSearchedKeywordValid } from 'utils/searchOverlayUtils';
import { fireGA4Script } from 'utils/common';
import Topic from './Topic';
import { WEB_TOPIC_GA_CATEGORY, TOI_LIVE_DOMAIN } from '../../../../constants';
import { loadPageAdCode } from '../../../../helpers/ads/revenueRedux';
import { loadHomePageData } from '../../../etimes_listing/redux';
// import newslistdata from '../../data/newslisting.json';

// const pageName = 'topic';

async function action(context, param) {
  const dataPromiseArray = [];
  const preDataLoadPromiseArray = [];
  const isAppView = isApp(context.query);
  const localParams = { 0: context.path };
  let frmEtimes = false;
  let topicPageType = 'nonCelebrity';
  // existing state
  // eslint-disable-next-line one-var
  let state = context.store.getState();
  const cd8 = '';
  let redirect;
  // const { query: { geolocation } = {} } = context;
  const isPrime = !!state.isPrime;
  let searchKeyword = '';
  const tabList = [
    'news',
    'photos',
    'videos',
    'books',
    'filmography',
    'awards',
  ];
  let page;
  const urlPath = context.pathname;
  if (urlPath) {
    const pathArr = urlPath.split('/');
    if (pathArr && pathArr.length > 0 && pathArr[2]) {
      searchKeyword = pathArr[2];
    }
  }
  if (param.page === 'movies') {
    param.page = 'filmography';
  }
  if (param && param.page) {
    page = tabList.includes(param.page) && param.page;
  }
  const curpg = 1;
  // Redirecting to main page accessed without pagination
  // try {
  //   if (param && param.curpg) {
  //     const parsedCurpg = parseInt(param.curpg, 10);
  //     curpg = parsedCurpg > 1 ? parsedCurpg : 1;
  //   }
  // } catch (e) {
  //   console.log('invalid valuer of curpg', param.curpg);
  //   curpg = 1;
  // }
  const isSearchKeyValid = isSearchedKeywordValid(decodeURI(searchKeyword));
  const newParams = {
    ...localParams,
    fullPath: urlPath || '/topic/',
    curpg,
    isWapView: false,
    isAppView,
    isPrime,
    getAboutData: true,
    searchKeyword,
    page,
  };
  if (typeof window === 'undefined') {
    if (!state.topic.searchRedirectionUrl) {
      preDataLoadPromiseArray.push(
        context.store.dispatch(loadSearchRedirectionData(newParams)),
      );
    }

    await Promise.all(preDataLoadPromiseArray);
  }

  // get updated state
  state = context.store.getState();
  const searchRedirectionUrl = _get(state, 'topic.searchRedirectionUrl');
  if (!searchRedirectionUrl) {
    if (!state.topic.contentsData) {
      // dataPromiseArray.push(context.store.dispatch(loadTopicData(newParams)));
      // dataPromiseArray.push(
      //   context.store.dispatch(loadPubOrderList(newParams)),
      // );
      dataPromiseArray.push(context.store.dispatch(loadTopStoriesData()));
    }

    // if (!state.topic.tabsData) {
    //   dataPromiseArray.push(context.store.dispatch(loadTopicTabData(newParams)));
    // }

    if (typeof window === 'undefined') {
      dataPromiseArray.push(context.store.dispatch(getSiteConfig()));
    }

    if (!state.topic.tabsData) {
      const data = await context.store.dispatch(loadTopicFilterData(newParams));
      const { tabsData, fromEtimes, topicData } = data;
      frmEtimes = fromEtimes;
      await context.store.dispatch(
        loadTopicData({
          params: newParams,
          tabsData,
          frmEtimes,
          topicData,
        }),
      );
    }
    if (!isAppView && (!state.header.data || !state.footer_v2.data)) {
      if (!frmEtimes) {
        dataPromiseArray.push(
          context.store.dispatch(loadLayoutDataTopic(newParams)),
        );
      } else {
        newParams.fullPath = '/entertainment';
        dataPromiseArray.push(
          context.store.dispatch(loadLayoutDataList(newParams)),
        );
      }
    }
    if (frmEtimes && !state.homepage_etimes.data) {
      newParams.fullPath = '/entertainment';
      dataPromiseArray.push(
        context.store.dispatch(loadHomePageData(newParams)),
      );
      topicPageType = 'celebrity';
    }
    // if (!state.topic.keywordsFacet) {
    //   dataPromiseArray.push(
    //     context.store.dispatch(loadKeywordsFacetData(newParams)),
    //   );
    // }
    // Route data calls start
    // const contextParams = context.params;
    // Route data calls end

    // wait for responses on server side
    if (typeof window === 'undefined') {
      await Promise.all(dataPromiseArray);
    }
  }

  // get updated state
  state = context.store.getState();
  // let ifTopicNotAvailable = false;
  // let redirectionCheck = false;
  const seoData = _get(state, 'topic.seo');

  //correct seo data as now we bring only news from server
  if (!page && seoData) {
    seoData.canonical =
      seoData.canonical && seoData.canonical.replace('/news', '');
    seoData.alternate =
      seoData.alternate && seoData.alternate.replace('/news', '');
    seoData.amphtml =
      seoData.amphtml && seoData.amphtml.replace('ampnews', 'ampdefault');
    seoData.noindexnofollow =
      seoData.noindexnofollow && seoData.noindexnofollow;
  }
  if (seoData) {
    // All non-traffic attracting search pages excluded from indexing
    const isTopicPage = state && state.topic && state.topic.topic;
    if (!isTopicPage && !seoData.searchValidity) {
      seoData.noindex = 'true';
    }
  }
  let status = 200;
  const title = 'Get Latest News Updates from Times Of India';
  const dataAvailable = !!state.topic;
  if (typeof window === 'undefined' && !dataAvailable) {
    status = 404;
  }

  if (param && param.curpg && typeof window === 'undefined' && status < 404) {
    status = 301;
    redirect = `/topic/${newParams.searchKeyword}${page ? `/${page}` : ''}`;
  }

  if (curpg > 1 && typeof window === 'undefined') {
    if (
      (page === 'photos' &&
        ((Array.isArray(state.topic.photo) && state.topic.photo.length === 0) ||
          !Array.isArray(state.topic.photo))) ||
      (page === 'videos' &&
        ((Array.isArray(state.topic.video) && state.topic.video.length === 0) ||
          !Array.isArray(state.topic.video))) ||
      (page === 'news' &&
        ((Array.isArray(state.topic.news) && state.topic.news.length === 0) ||
          !Array.isArray(state.topic.news))) ||
      (!page &&
        ((state.topic.contentsData &&
          Array.isArray(state.topic.contentsData.items) &&
          state.topic.contentsData.items.length === 0) ||
          (!state.topic.contentsData ||
            (state.topic.contentsData && !state.topic.contentsData.items))))
    ) {
      status = 301;
      redirect = `/topic/${newParams.searchKeyword}`;
    }
  }

  const gaCategory = WEB_TOPIC_GA_CATEGORY;

  const topicdata =
    typeof state.topic !== 'undefined' &&
    typeof state.topic.topic !== 'undefined' &&
    state.topic.topic;
  const topicType = _get(topicdata, 'types', undefined);
  // checking if topic is celebrity or cricketer then need toserve this from xslt page
  if (
    Array.isArray(topicType) &&
    topicType.length &&
    topicType.indexOf('Cricketer') > -1
  ) {
    status = 404;
  }
  if (seoData && seoData.isServeFromJCMS) {
    status = 404;
  }
  if (!state?.topic?.topic && topicPageType !== 'celebrity') {
    topicPageType = 'search';
  }
  const getAdsTargetingObj = () => {
    const metaKeywords = _get(seoData, 'keywords', '');
    const contentURL = `${TOI_LIVE_DOMAIN}${context.pathname}`;
    const navKeyObj = setSubSecNavFrmUrl(contentURL);
    const adConfig = {
      Tmpl_SCN: 'Listing',
      Channel: 'toi',
      ...navKeyObj,
    };
    return {
      Meta_Keywords: metaKeywords,
      Content_URL: contentURL,
      topicpagetype: topicPageType,
      ...adConfig,
    };
  };

  const isMoreThanOneTopic = !!(
    typeof state.topic !== 'undefined' && state.topic.isMoreThanOneTopic
  );

  if (status < 404 && seoData && seoData.redirectionUrl) {
    status = 301;
    redirect = seoData.redirectionUrl;
  }

  if (status < 404 && !isMoreThanOneTopic) {
    let isMatched = false;
    const aliases = _get(topicdata, 'aliases', undefined);
    const topicTitle =
      topicdata && topicdata.title && topicdata.title.toLowerCase();
    const isTitleMatched = !!(
      searchKeyword &&
      topicTitle &&
      topicTitle === decodeURI(searchKeyword.toLowerCase())
    );

    if (Array.isArray(aliases) && aliases.length && searchKeyword) {
      for (let i = 0; i < aliases.length; i += 1) {
        if (
          aliases[i] &&
          aliases[i].toLowerCase() === decodeURI(searchKeyword.toLowerCase())
        ) {
          isMatched = true;
          break;
        }
      }
    }
    const isUidMatched = !!(
      topicdata &&
      topicdata.uid &&
      searchKeyword &&
      topicdata.uid.toLowerCase() === decodeURI(searchKeyword.toLowerCase())
    );

    if (
      topicdata &&
      topicdata.uid &&
      (isMatched || isTitleMatched || isUidMatched) &&
      topicdata.uid !== decodeURI(searchKeyword)
    ) {
      let curUrl = urlPath;
      const urlAr = curUrl.split('/');
      if (Array.isArray(urlAr) && urlAr.length > 2) {
        urlAr[2] = topicdata.uid;
        curUrl = urlAr.join('/');
      }
      status = 301;
      redirect = curUrl;
    }

    if (
      !(state.topic && state.topic.topic && state.topic.topic.uid) &&
      isSearchKeyValid
    ) {
      let curUrl = urlPath;
      const urlAr = curUrl.split('/');
      if (
        Array.isArray(urlAr) &&
        urlAr.length > 2 &&
        urlAr[2] !==
          decodeURI(urlAr[2])
            .replace(/\s+/g, '-')
            .toLowerCase()
      ) {
        urlAr[2] = decodeURI(urlAr[2])
          .replace(/\s+/g, '-')
          .toLowerCase();
        curUrl = urlAr.join('/');
        status = 301;
        redirect = curUrl;
      }
    }
  }
  // let aboutData = null;
  // if (state.topic && state.topic.topic) {
  //   aboutData = { ...state.topic.topic };
  // }

  if (
    typeof window === 'undefined' &&
    status < 301 &&
    !searchRedirectionUrl &&
    curpg &&
    curpg === 1 &&
    page &&
    state.topic &&
    state.topic.totalCount &&
    state.topic.totalCount > 0 &&
    ((page === 'photos' &&
      !(
        state.topic.photo &&
        Array.isArray(state.topic.photo) &&
        state.topic.photo.length > 0
      )) ||
      (page === 'videos' &&
        !(
          state.topic.video &&
          Array.isArray(state.topic.video) &&
          state.topic.video.length > 0
        )))
  ) {
    status = 301;
    redirect = `/topic/${newParams.searchKeyword}`;
  }

  if (searchRedirectionUrl) {
    status = 301;
    redirect = searchRedirectionUrl;
  }

  const isTopicPage = state && state.topic && state.topic.topic;
  const isAdRemoved = state?.isPrime;
  frmEtimes = _get(state, `topic.fromEtimes`, false);

  let adsTargetingObj = {};
  if (!state.isPrime) {
    adsTargetingObj = getAdsTargetingObj();
    if (typeof window === 'undefined' && status === 200) {
      const caimpaignConfig = checkJarvisAdsConfigForSS({
        jarvisConfig: _get(state, 'common.siteConfig.revenue', {}),
        pathname: context?.pathname,
        isWapView: false,
        ...adsTargetingObj,
      });
      context.store.dispatch(updateCaimpaignAdsConfig(caimpaignConfig));
      const jpiconfig = {
        Tmpl_SCN: 'topic',
        platform: 'web',
        Channel: frmEtimes ? 'etimes' : 'toi',
      };
      await context.store.dispatch(loadPageAdCode(jpiconfig));
      state = context.store.getState();
    }
  }
  const getComponent = async pageTitle => {
    // if (typeof window === 'undefined' && !dataAvailable) {
    //   return (
    //     <div>
    //       Something went wrong. Click{' '}
    //       <a href="https://timesofindia.indiatimes.com">here</a> to browse TOI
    //     </div>
    //   );
    // }

    if (typeof window !== 'undefined') {
      window.categoryForGA = gaCategory;
      if (state && state.topic && state.topic.topic) {
        window.categoryForSearchGA = 'WEB-TOI-Topic';
      } else window.categoryForSearchGA = 'WEB-TOI-Search';
    }

    const pageRefreshTime = _get(
      state,
      `common.siteConfig.abexperiment.pagerefresh.refreshminutes.topic`,
      0,
    );

    const { default: Layout } = frmEtimes
      ? await import(/* webpackChunkName: "etimestopiclayout" */ 'components_v2/desktop/ETimesLayout')
      : await import(/* webpackChunkName: "toitopiclayout" */ 'components_v2/desktop/Layout/');
    const revenueAdsData = _get(state, 'revenue.data.ads');

    const props = {
      layoutClass: frmEtimes ? 'layout_type_2' : '',
      title: pageTitle,
      params: newParams,
      query: Object.keys(context.query).length ? context.query : {},
      adPosition: 'masthead',
      pageType: 'topic',
      showMiniTv: false,
      miniTvV2: true,
      desktopAdCode: _get(revenueAdsData, 'layout.masthead', undefined),
      gutterAdCode: _get(revenueAdsData, 'layout.gutter', undefined),
      skipAds: isAdRemoved,
      hideAds: isAdRemoved,
      hideAdBlockerDetector: isAdRemoved,
      pathname: context.pathname,
    };

    return (
      <Layout {...props}>
        <Topic
          // tabContentData={state.topic.tabContentData}
          newsData={state.topic.contentsData}
          topicData={state.topic.topic}
          news={state.topic.news}
          photos={state.topic.photo}
          videos={state.topic.video}
          searchKeyword={newParams.searchKeyword}
          isWapView={newParams.isWapView}
          page={newParams.page}
          isPrime={state.isPrime} // page will not render ads as for prime user for search pages
          // tabsData={state.topic.tabsData}
          // keywordsFacet={state.topic.keywordsFacet}
          // lhsFilters={state.topic.lhsFilters}
          // totalCount={state.topic.totalCount}
          params={newParams}
          gaCategory={gaCategory}
          refreshTime={parseFloat(pageRefreshTime, 10)}
          curpg={curpg}
        />
      </Layout>
    );
  };
  let contentType = isTopicPage ? 'Topic' : 'Search';

  const isAuthor = _get(state, `topic.isAuthor`, false);
  if (frmEtimes) {
    if (isAuthor) {
      contentType = 'Author';
    } else {
      contentType = 'Celebs';
    }
  }

  if (typeof window !== 'undefined') {
    fireGA4Script({ params: { frmEtimes, contentType } });
  }

  const getChunkName = async () => {
    const val = frmEtimes ? 'etimestopiclayout' : 'toitopiclayout';
    return val;
  };

  return {
    title,
    chunks: ['topicdesktop', await getChunkName()],
    seoData: {
      ...seoData,
      schema: [
        {
          data:
            state.topic.schema && state.topic.schema[0]
              ? state.topic.schema[0]
              : '',
        },
        {
          data:
            state.topic.schema && state.topic.schema[1]
              ? state.topic.schema[1]
              : '',
        },
        {
          data:
            state.topic.schema && state.topic.schema[2]
              ? state.topic.schema[2]
              : '',
        },
      ],
    },
    status,
    component: await getComponent(title),
    maxAge: 43200,
    gaData: {
      dimension9: state.topic && state.topic.topic ? 'topic' : 'search',
      dimension8: cd8,
    },
    adsTargetingObj,
    preconnectDomains: ['//tpapi.timespoints.com'],
    skipGpt: true,
    pwtHeadTags: true,
    headTags: [...commonHeadScripts],
    isPrime: state.isPrime,
    redirect,
    skipPageViewGAOnLoad: false,
    isPerfExperimented: true,
    useVariableFonts: true,
    inlineFirstFoldCSS: false,
    skipRouteAds: isAdRemoved,
    ga3PageViewEtimesParams: frmEtimes ? 'et=entertainment' : '',
    preventUserActionOnNIElements: true,
  };
}

export default action;
